import styled from "styled-components";

export const TournamentStateInfoWrapper = styled.div`
  margin: 0 16px;
  height: 163px;
  border-radius: 9px;
  box-shadow: 0px 0px 12px 0px #00000040;
  background: #fff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const CircularProgress = styled.svg`
  width: 57px;
  height: 57px;
  border-radius: 50%;
  transform: rotate(0.25turn);

  circle {
    fill: none;
    stroke-width: 8;
  }

  .background {
    stroke: #fff;
  }

  .progress {
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1);
    transform-origin: center;
  }
`;

export const TournamentStateInfoTimerWrapper = styled.div<{ progress: number }>`
  justify-content: start;
  display: flex;
  gap: 8px;
  align-items: flex-start;

  > .time-box {
    position: relative;
    width: 73px;
    height: 73px;
    border-radius: 14px;
    background: rgba(100, 54, 231, 1);
    display: flex;
    justify-content: center;
    align-items: center;

    .donut-container {
      position: relative;
      top: 8px;
      left: 8px;
      width: 57px;
      height: 57px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .donut-border {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      border: 4px solid transparent;
      border-color: white;
    }

    .donut-progress {
      position: absolute;
      right: 0px;
      transform: rotateZ(${(props) => 360 - (360 * props.progress) / 100}deg);
    }

    .time {
      color: white;
      font-size: 14px;
      font-weight: bold;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .lv-col {
    justify-content: space-between;
    flex: 1;
    .lv {
      font-size: 20px;
      font-weight: 600;
      line-height: 23.87px;
      letter-spacing: -0.02em;
      text-align: left;
    }
    .break {
      font-size: 10px;
      font-weight: 400;
      line-height: 11.93px;
      text-align: left;
    }

    .break-time {
      margin-top: 4px;

      font-size: 15px;
      font-weight: 700;
      line-height: 17.9px;
      text-align: left;
    }
  }
`;

export const TournamentStateInfoLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  > .lv {
    font-size: 20px;
    font-weight: 600;
    line-height: 23.87px;
    letter-spacing: -0.02em;
    text-align: left;
  }
  > .entry {
    font-weight: 600;
    font-size: 14px;
  }
`;

export const TournamentStateInfoBlindWrapper = styled.div`
  display: flex;
  background: #ecf0f3;
  height: 45px;
  border-radius: 8px;
  align-items: center;

  > .item {
    flex: 1;
    display: flex;
    gap: 2px;
    flex-direction: column;
    border-right: 0.5px solid #12121280;

    &:last-child {
      border-right: none;
    }

    > .name {
      font-weight: 400;
      font-size: 9px;
      text-align: center;
      color: #121212;
    }

    > .blind {
      font-weight: 700;
      font-size: 10px;
      text-align: center;
    }
  }
`;
